import { Theme } from '@mui/material/styles';

export const chipStyles = {
  styleOverrides: {
    colorSuccess: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.green['6'],
      backgroundColor: theme.palette.green['10'],
    }),
    colorError: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.red['1'],
      background: theme.palette.red['5'],
    }),
  },
};
